import { Components, Theme } from '@mui/material/styles';

export default function Switch(theme: Theme): Components {
  return {
    MuiSwitch: {
      styleOverrides: {
        root: {
          '& .MuiSwitch-switchBase': {
            color: theme.palette.grey[400],
            '&:hover': {
              background: 'none',
            },
            '& + .MuiSwitch-track': {
              backgroundColor: theme.palette.grey[400],
            },
            '&.Mui-checked': {
              color: theme.palette.primary.main,
              '&:hover': {
                background: 'none',
              },
              '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.primary.main,
              },
            },
          },
        },
      },
    },
  };
}
